import React from 'react'
import styled from 'styled-components'
import { colors } from '../../colors'
import { Link } from 'react-router-dom'

import { FaCode, FaFacebook, FaTwitter, FaLinkedin } from "react-icons/fa";

const Footer = () => {
  return (
    <Container>

        <FooterCont>


        <InnerContainer>
            <h2>Find Us</h2>
            <p>SANUSI DANTATA HOUSE, PLOT 274, CENTRAL BUSINESS DISTRICT, P.M.B 1, ABUJA.</p>
            <h5>Talk to us +(234) 805 425 5169 Available 24/7</h5>

            <ul className="socials">
               <li className="social_item">
                  <a 
                    href='https://www.facebook.com/nationallibraryofnigeria' target='_blank'> 
                    <FaFacebook size={'20px'} /></a> 
                </li> 

               <li className="social_item" >
                  <a  
                    href='https://www.twitter.com/librarygovng' target='_blank'>
                    <FaTwitter size={'20px'}/></a> 
                </li> 

                
                <li className="social_item" >
                  <a href='https://www.linkedin.com' target='_blank'><FaLinkedin size={'20px'}/></a> 
                </li> 
                
            </ul>

        </InnerContainer>

        <InnerContainer>
            <h2>Services</h2>
            <ul>
                <li> <Link to='https://webindex.nlndata.com.ng/'>Indexing Services</Link></li>
                <li><Link to='https://www.nln.gov.ng/Home/DepartmentDetails/2'>Public Services</Link></li>
                <li><Link to="https://www.nln.gov.ng/Home/DepartmentDetails/7" target={'_blank'}>E-Library Services</Link></li>
                <li><Link to='#'>Supboena Services</Link></li>
                <li><Link to='http://opac.nln.gov.ng/'>OPAC</Link></li>
                <li> <a href="#">List of Practising Librarians</a> </li>
            </ul>

        </InnerContainer>

        <InnerContainer>
            <h2>Operations</h2>
            <ul>
                <li> <a href="https://www.nln.gov.ng/Home/DepartmentDetails/3" target={'_blank'}>CDTS</a> </li>
                <li> <a href="https://www.nln.gov.ng/Home/DepartmentDetails/5" target={'_blank'}>Legal Deposits</a> </li>
                <li> <a href="https://www.nln.gov.ng/Home/DepartmentDetails/6" target={'_blank'}>International Standard</a> </li>
                <li> <a href="https://www.nln.gov.ng/Home/DepartmentDetails/4" target={'_blank'}>Planning, Research & Statistics </a> </li>
                <li> <a href="https://www.nln.gov.ng/Home/DepartmentDetails/7" target={'_blank'}>Digitization</a> </li>
            </ul>

        </InnerContainer>

        <InnerContainer>
            <h2>Collections</h2>
            <ul>
                <li><Link to='http://repository.nln.gov.ng'>National Repository</Link></li>
                <li><Link to='/nigeriana'>Nigeriana</Link></li>
                <li><Link to='#'>Bold Scholar</Link></li>
                <li><Link to="https://www.nln.gov.ng/Home/DepartmentDetails/7" target={'_blank'}>E-Library Services</Link></li>
                
            </ul>

        </InnerContainer>

        {/* <InnerContainer>
            <h2>Government Establishments</h2>
            <ul>
                <li> <Link to='#'>Ministries & Agencies</Link></li>
                <li><Link to='#'>Register for ISBN</Link></li>
                <li><Link to='#'>Bold Scholar</Link></li>
                <li><Link to='#'>E-library</Link></li>
                
            </ul>

        </InnerContainer>

        <InnerContainer>
            <h2>Programs</h2>
            <ul>
                <li> <Link to='#'>Waiting for list</Link></li>
                <li><Link to='#'>Waiting for list</Link></li>
                <li><Link to='#'>Bold Scholar</Link></li>
                <li><Link to='#'>E-library</Link></li>
                
            </ul>

        </InnerContainer> */}
        </FooterCont>

        <ul>
            <li> <a href="#" target={'_blank'}>Ministries and Agencies</a> </li>
              <li> <a href="https://issnisbn.nlndata.com.ng/" target={'_blank'}>Register for ISBN</a> </li>
            <li> <a href="#" target={'_blank'}>Programs</a> </li>
        </ul>
       

        <h4>Made with <span>&hearts;</span> 	  by 
            <a href="https://www.wissenschaft.com.ng/" target={'_blank'}> Wissenschaft Integrated Limited</a> 
        </h4>
    </Container>
  )
}

const Container = styled.footer`
    width: 100%;
    /* max-width: 1250px; */
    
    background-color: ${colors.primary};
    padding: 70px 120px 10px;

    & > ul{
        
        display: flex;
        justify-content: space-between;
        width: 50%;
        margin: 40px auto;
        /* border: 1px solid ; */

        & > li {
            color: #fff;
            font-size: 1.5rem;
            width: max-content;

            & > a{
                color: #fff;
            }
        }
    }

    @media screen and (max-width: 450px){
        padding: 30px 20px;
        }

    & > h4{
        padding-top: 20px;
        font-size: 1.2rem;
        text-align: center;
        color: #fff;

        & > a{
            color: #fff;

            &:hover{
                opacity: 0.7;
            }
        }

        & > span{
            color: red;
            font-size: 15px;
        }
    }
`

const FooterCont = styled.div`
    max-width: 1250px;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    flex-wrap: wrap;
    margin: 0 auto;
`

const InnerContainer = styled.div`
    display: flex;
    flex-direction: column;
    color: ${colors.white};
    /* width: 25%; */
    /* justify-content: flex-start; */
    align-items: flex-start;

    & > ul{
        align-self: flex-start;
    }

    & p{
        text-align: left;
        font-size: 14px;
        width: 80%;
    }

    & h5{
        padding-top: 10px;
    }

    & li{
        color: ${colors.white};
        font-size: 14px;
        text-align: left;
        padding-top: 10px;
        width: 95%;
        /* border: 1px solid red; */
    }

    & a{
        color: ${colors.white};
        text-align: left;
    }

    & > h4{

        
    }
`

export {Footer}